import {Segment} from '@britishcouncil/react-extro-ui';

import {PrsToPay} from "../../../../../store/post-results-services/postResultsServicesApi";

import SideSectionSummarySegment from "./SideSectionSummarySegment";
import SideSectionProductList from "./SideSectionProductList";
import * as S from './SideSectionProductsSummary.styles';

export interface ProductsSummaryProps {
    total: string;
    prss: PrsToPay[];
    taxInfo?: string;
}
const SideSectionProductsSummary = ({total, prss, taxInfo}: ProductsSummaryProps) => {

    const withTitle = !!prss?.length;

    return (
        <SideSectionSummarySegment>
            <Segment color="blue" elevation={0}>
                {withTitle && <S.SegmentTitle>Payment summary:</S.SegmentTitle>}

                {prss.map(prs => <SideSectionProductList
                    columnHeaders={['Component', 'Price']}
                    subtitle={prs.examOptionCode}
                    title={prs.syllabusName}
                    items={prs.components.map(c => ({label: c.componentName, amount: `${c.fee} ${c.currency}`}))}
                />)}
                
                <S.Summary>
                    <S.Divider/>
                    {total && (
                        <S.Total>
                            <h5>Total price:</h5>
                            <S.TotalPrice>
                              {total}
                              <S.TaxInfo>
                                <br />
                                {taxInfo}
                              </S.TaxInfo>
                            </S.TotalPrice>                     
                        </S.Total>
                    )}
                    <S.Divider/>
                </S.Summary>
            </Segment>
        </SideSectionSummarySegment>
    );
};

export default SideSectionProductsSummary;
